import { useState } from "react";

/**
 * Custom hook for managing template-related state
 */
export const useTemplateState = () => {
    const [selectedTemplate, setSelectedTemplate] = useState<number>(0);
    const [selectedTemplateContent, setSelectedTemplateContent] = useState<string>("");
    const [selectedTemplateContentId, setSelectedTemplateContentId] = useState<string>("");
    const [hideDynamicTemplatePopup, setHideDynamicTemplatePopup] = useState(false);
    const [templateKeyWords, setTemplateKeywords] = useState<string>("");
    const [changingTemplateContent, setChangingTemplateContent] = useState<boolean>(false);
    const [activateTemplateTour, setActivateTemplateTour] = useState<boolean>(false);

    return {
        selectedTemplate,
        setSelectedTemplate,
        selectedTemplateContent,
        setSelectedTemplateContent,
        selectedTemplateContentId,
        setSelectedTemplateContentId,
        hideDynamicTemplatePopup,
        setHideDynamicTemplatePopup,
        templateKeyWords,
        setTemplateKeywords,
        changingTemplateContent,
        setChangingTemplateContent,
        activateTemplateTour,
        setActivateTemplateTour
    };
};
